/* eslint-disable no-console */
import { DRAFT_CHANGED, SOCKET } from '../constants/actionTypes/sockets';
import * as canvasBlocks from '../constants/actionTypes/canvasBlocks';
import * as columnItems from '../constants/actionTypes/columnItem';
import * as selectedElements from '../constants/actionTypes/selectedElements';
import * as column from '../constants/actionTypes/column';

const draftChangeEvents = [
    column.SPLIT_COLUMN,
    column.MERGE_COLUMN,
    column.MOVE_COLUMN,
    column.UPDATE_COLUMN_SIZING,
    columnItems.UPDATE_COLUMN_ITEM_CONTENT,
    columnItems.REFRESH_COLUMN_ITEM_CONTENT,
    columnItems.MOVE_COLUMN_ITEM_CONTENT_TO_ANOTHER_COLUMN,
    columnItems.DUPLICATE_COLUMN_ITEM,
    columnItems.DELETE_COLUMN_ITEM,
    columnItems.ADD_NEW_COLUMN_ITEM,
    columnItems.UPDATE_COLUMN_ITEM_CONTENT_IN_MULTIPLE_BLOCKS,
    columnItems.UPDATE_COLUMN_ITEM_FONT_IN_MULTIPLE_BLOCKS,
    canvasBlocks.SWITCH_LOCK_STRUCTURE,
    canvasBlocks.ADD_BLOCK,
    canvasBlocks.DUPLICATE_BLOCKS,
    canvasBlocks.DELETE_BLOCKS,
    canvasBlocks.MOVE_BLOCKS,
    canvasBlocks.SWAP_BLOCKS,
    canvasBlocks.REMOVE_BLOCK,
    canvasBlocks.UPDATE_BLOCKS_PROPERTIES,
    canvasBlocks.LOCK_BLOCKS,
    canvasBlocks.POPULATE_INITIAL_BLOCKS,
    '@@redux-undo/UNDO',
    '@@redux-undo/REDO',
];

const selectionEvents = [
    selectedElements.ADD_SELECTED_ELEMENT,
    selectedElements.SELECT_ALL_ELEMENTS,
    selectedElements.REMOVE_SELECTED_ELEMENT,
    selectedElements.REMOVE_ALL_SELECTED_ELEMENTS,
];

const emitCases = [...draftChangeEvents, ...selectionEvents];

/**
 * Lets the server know a change in the draft happened
 * Declared here to prevent dependency cycle
 * @param {Object} action
 * @param {string} action.type The action type
 * @param {Object} action.payload The payload to share with other clients
 */
export const draftChange = ({ type, payload }) => ({
    type: SOCKET,
    promiseArray: [(socket) => socket.emit(DRAFT_CHANGED, { type, payload })],
});

const updateRemoteSocketIdIfNeeded = (currentUser, payload, socketId) => {
    if (payload.remote) {
        const remoteUser = payload.remote;

        if (currentUser.email === remoteUser.email) {
            payload.remote.socketId = socketId;
        }
    }
};

const socketsMiddleware =
    (socket) =>
    ({ dispatch, getState }) =>
    (next) =>
    (action) => {
        const { promiseArray, type, payload, remote } = action;

        if (socket.plan !== 'IC_LEGACY') {
            if (remote) {
                const socketId = socket.socket.id;

                // When user leaves and reconnects to the Email Designer,
                // his socketId changes. In result, we have different socketIds
                // stored in current session and in historical data from previous actions.
                // This hack replaces "previous" user's socketId by the current one.
                updateRemoteSocketIdIfNeeded(getState().session.user, payload, socketId);

                action.payload = {
                    ...payload,
                    currentUserSocketId: socketId,
                };
                return next(action);
            }

            if (emitCases.includes(type) && socket.socket) {
                dispatch(draftChange({ type, payload }));
                return selectionEvents.includes(type) ? next(action) : null;
            }
        }

        if (type !== SOCKET || !promiseArray) {
            if (typeof action === 'function') {
                return action(dispatch, getState);
            }
            return next(action);
        }

        return promiseArray.map((promise) =>
            promise(socket).catch((err) => {
                console.error(err);
            })
        );
    };

export default socketsMiddleware;
